import { useEffect } from 'react';
import { supabase } from './supabase';
import { setToken } from './session';

/** Keeps the plain `session.ts` token store in sync with Supabase's own session, when configured. */
export function SupabaseSessionSync() {
  useEffect(() => {
    if (!supabase) return;

    supabase.auth.getSession().then(({ data }) => {
      setToken(data.session?.access_token ?? null);
    });

    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => {
      setToken(session?.access_token ?? null);
    });

    return () => subscription.subscription.unsubscribe();
  }, []);

  return null;
}
